import React, { useState, useEffect } from "react";
import { pushEventToDataLayer } from "../../helper/datalayer-utils";
import "./new-body-banner.m.css";

const NewBodyWidget = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleBannerClick = () => {
    console.log("ePaper Banner clicked");
    window.open(
      "https://epaper.deccanherald.com/?utm_source=dhsite&utm_medium=inarticle_banner&utm_campaign=awareness",
      "_blank"
    );
    if (window?.dataLayer) pushEventToDataLayer("ePaper_banner");
  };

  const desktopImage = "https://tpml-sites.s3.ap-south-1.amazonaws.com/images/Desktop_Article.png";
  const mobileImage = "https://tpml-sites.s3.ap-south-1.amazonaws.com/images/MW_articlepage.png";

  const height = isMobile ? "74px" : "103px";

  return (
    <section styleName="epaper-banner" onClick={handleBannerClick} style={{ height, overflow: "hidden" }}>
      <div styleName="epaper-left">
        <img
          src={isMobile ? mobileImage : desktopImage}
          alt="E-paper on multiple devices"
          styleName="epaper-device"
        />

        <div styleName="epaper-text">
          <h2 styleName="epaper-heading">
            <span>ANYTIME, ANYWHERE.</span>
          </h2>

          {!isMobile && (
            <p styleName="epaper-subheading">
              Experience a more refined e-paper today
            </p>
          )}
        </div>
      </div>

      <button styleName="epaper-cta">
          Read E-Paper
      </button>
    </section>
  );
};

export default NewBodyWidget;
